__turbopack_context__.v({
  "bar": "UtilityBar-module-scss-module__A1akAq__bar",
  "fade-in": "UtilityBar-module-scss-module__A1akAq__fade-in",
  "label": "UtilityBar-module-scss-module__A1akAq__label",
  "no-transform": "UtilityBar-module-scss-module__A1akAq__no-transform",
  "rotate": "UtilityBar-module-scss-module__A1akAq__rotate",
});
